import { CreateControleServicosRequest } from "../../../data/daos/create/create_controle_servicos";
import { ICreateControleServicosUseCase } from "../../../presentation/useCases/create/create_controle_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateControleServicosUseCase
 */

export class CreateControleServicosUseCase implements ICreateControleServicosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async createControleServicos(modal: CreateControleServicosRequest): Promise<void> {
    await this.repository.postControleServicosCreate(modal);
  }
}
